var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgFacebook = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 1.875A10.125 10.125 0 1022.125 12 10.137 10.137 0 0012 1.875zm1.125 17.918v-5.168H15a1.125 1.125 0 100-2.25h-1.875V10.5a1.125 1.125 0 011.125-1.125h1.5a1.125 1.125 0 000-2.25h-1.5a3.375 3.375 0 00-3.375 3.375v1.875H9a1.125 1.125 0 100 2.25h1.875v5.168a7.875 7.875 0 112.25 0z"
})));
export default SvgFacebook;